import { ChannelItemRender, ChannelItemUnion } from '../types/ChannelItem';

export const groupMessagesByDateOld = (messages: ChannelItemUnion[]): ChannelItemRender[] => {
    const threshold = 5 * 60 * 1000; // 5 minutes in milliseconds

    return messages.reduce<ChannelItemRender[]>((acc, message, index, arr) => {
        const nextMessage = index < arr.length - 1 ? arr[index + 1] : null;
        const messageDate = new Date(message.date);
        const nextMessageDate = nextMessage ? new Date(nextMessage.date) : null;

        acc.push({ type: 'item', item: message });

        const shouldDisplayHeader =
            !nextMessageDate ||
            Math.abs(nextMessageDate.getTime() - messageDate.getTime()) > threshold;
        if (shouldDisplayHeader) {
            const headerDate = new Date(message.date);
            acc.push({ type: 'header', item: headerDate });
        }

        return acc;
    }, []);
};

export const groupMessagesByDate = (messages: ChannelItemUnion[]): ChannelItemRender[] => {
    return messages
        .reduceRight<ChannelItemRender[]>((acc, message, index, arr) => {
            const messageDate = new Date(message.date);
            const currentGroup = acc[acc.length - 1];
            const currentGroupDate =
                currentGroup &&
                currentGroup.type === 'item' &&
                new Date((currentGroup.item as ChannelItemUnion).date);
            const sameDay =
                currentGroupDate &&
                messageDate.getDate() === currentGroupDate.getDate() &&
                messageDate.getMonth() === currentGroupDate.getMonth() &&
                messageDate.getFullYear() === currentGroupDate.getFullYear();

            if (!sameDay) {
                const headerDate = new Date(message.date);
                acc.push({ type: 'header', item: headerDate });
            }

            acc.push({ type: 'item', item: message });
            return acc;
        }, [])
        .reverse();
};
